<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <upload @updatedSrc="getSrc" :preview="tile"></upload>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="tile.title"
            type="text"
            placeholder="Tile title"
            id="title"
          ></v-text-field>
          <v-text-field
            label="Vision Title"
            v-model.trim="tile.visionTitle"
            type="text"
            placeholder="Vision title"
            id="visionTitle"
          ></v-text-field>
          <v-textarea
            name="Vision"
            label="Vision"
            v-model.trim="tile.vision"
            type="text"
            placeholder="Vision"
            id="vision"
            :color="theme"
          ></v-textarea>
          <v-text-field
            label="Social Title"
            v-model.trim="tile.socialTitle"
            type="text"
            placeholder="Social title"
            id="socialTitle"
          ></v-text-field>
          <v-textarea
            name="Social"
            label="Social"
            v-model.trim="tile.social"
            type="text"
            placeholder="Social"
            id="social"
            :color="theme"
          ></v-textarea>
          <v-text-field
            label="Collections Title"
            v-model.trim="tile.collectionsTitle"
            type="text"
            placeholder="Collections title"
            id="collectionsTitle"
          ></v-text-field>
          <v-textarea
            name="Collections"
            label="Collections"
            v-model.trim="tile.collections"
            type="text"
            placeholder="Collections"
            id="collections"
            :color="theme"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { Upload } from "@/components/functionality";

export default {
  name: "AdminBenchmarkUpload",
  components: { Upload },
  data() {
    return {
      isValid: true,
      theme: "amber",
    };
  },
  props: {
    tile: Object,
  },
  methods: {
    getSrc(val) {
      this.tile.src = val;
    },
    validateImage(val) {
      this.isValidImage = val;
    },
  },
};
</script>
